var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 6.66666C14.6596 6.66666 15.9313 7.19345 16.869 8.13113C17.8067 9.06881 18.3335 10.3406 18.3335 11.6667V17.5H15.0002V11.6667C15.0002 11.2246 14.8246 10.8007 14.512 10.4882C14.1994 10.1756 13.7755 10 13.3335 10C12.8915 10 12.4675 10.1756 12.155 10.4882C11.8424 10.8007 11.6668 11.2246 11.6668 11.6667V17.5H8.3335V11.6667C8.3335 10.3406 8.86028 9.06881 9.79796 8.13113C10.7356 7.19345 12.0074 6.66666 13.3335 6.66666V6.66666Z",
    stroke: "#97A0AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 7.5H1.6665V17.5H4.99984V7.5Z",
    stroke: "#97A0AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 5C4.25364 5 4.99984 4.25381 4.99984 3.33333C4.99984 2.41286 4.25364 1.66666 3.33317 1.66666C2.4127 1.66666 1.6665 2.41286 1.6665 3.33333C1.6665 4.25381 2.4127 5 3.33317 5Z",
    stroke: "#97A0AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b0c5491a18936b447e4d4e1bef310a43.svg";
export { ForwardRef as ReactComponent };